var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSaveWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 39,
    viewBox: "0 0 34 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4322 1.0918H2.3375C1.84044 1.0918 1.4375 1.49474 1.4375 1.9918V36.5528C1.4375 37.2268 2.1511 37.6616 2.75011 37.3526L16.7564 30.1273C17.0197 29.9915 17.333 29.9939 17.5941 30.1338L31.0072 37.3198C31.6067 37.6411 32.3322 37.2067 32.3322 36.5265V1.9918C32.3322 1.49474 31.9292 1.0918 31.4322 1.0918Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSaveWhite);
export default __webpack_public_path__ + "static/media/IconSaveWhite.e44e8ec11929e554ed5f0f0880d52a78.svg";
export { ForwardRef as ReactComponent };